export default __webpack_public_path__ + "static/media/background image.a9ec5191.jpg";